<template>
  <div>
    <h1>Nova Lição</h1>

    <input
      v-model="tituloLicao"
      type="text"
    >

    <button @click="confirm()">
      Salvar
    </button>
    <button @click="close()">
      Cancelar
    </button>
  </div>
</template>

<script>
import { bus } from "@/main"

export default {
    name: "NovaLicao",
    props: ['data'],
    data() {
        return {
            tituloLicao: ""
        }
    },
    methods: {
        close() {
            this.$emit("input")
        },
        confirm() {
            bus.$emit("novaLicao", {
                titulo: this.tituloLicao,
                key: this.data
            })
            this.$emit("input")
        }
    },
}
</script>

<style>

</style>